import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ReferenceParams, Res } from 'src/app/models';
import { ApiMarkingProductListService, ApiProductsService, LanguageService, NotificationService, ValidatorsService } from 'src/app/services';
import { MarkingProductCreateValidator } from './marking-product-create.validators';

@Component({
  selector: 'app-marking-product-create',
  templateUrl: './marking-product-create.component.html',
  styleUrls: ['./marking-product-create.component.css']
})
export class MarkingProductCreateComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  errorMessages: any;
  products: any[] = [];

  form: UntypedFormGroup = this.fb.group({
    products_id: [null, this.validator.products_id],
  });

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    public activeModal: NgbActiveModal,
    private apiProducts: ApiProductsService,
    private apiMarkingProductService: ApiMarkingProductListService,
    private notification: NotificationService,
    private languageService: LanguageService,
    private validator: MarkingProductCreateValidator,
    private validatorService: ValidatorsService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.errorMessages = this.validator.errorMessages;

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

    this.getProducts();
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }

  /**
  * 
  * @param searchValue 
  */
  getProducts(searchValue: string = ''): void {

    let params: ReferenceParams = {
      filter: {
        name: searchValue
      }
    }

    this.loading = true;
    this.products = [];

    this.subscriptions.add(
      this.apiProducts.getReferences(params, 'products').subscribe((response: Res) => {
        console.log('[RESPONSE] getProducts: ', response);

        if (response != null) {

          this.products = response.result;
        }

        this.loading = false;
      },
        error => {
          this.loading = false;
          this.products = [];
        })
    );
  }

  /**
 * 
 */
  onCreate() {

    this.progressRef.start();

    let data = { ...this.form.value };

    this.subscriptions.add(
      this.apiMarkingProductService.save(data).subscribe((response: Res) => {

        if (response != null) {

          this.notification.show('success', 'Данные успешно сохранены!');
          this.activeModal.close(response);
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  
  /**
   * 
   * @param field 
   * @param type 
   */
   validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }


}
